"use strict";

/**
 * @classdesc
 * Erzeugt eine neue Gruppe innerhalb des Layertree.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte
 */
gc.gis.action.layer.NewGroupLayer = function(options)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * @inheritdoc
	 */
	this.func = this.doExecute;
	/**
	 * @inheritdoc
	 */
	this.args = [options.map];
};
gc.gis.action.layer.NewGroupLayer.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Erzeugt eine neue Gruppe innerhalb des Layertree.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.NewGroupLayer.prototype.doExecute = function(map)
{
	var parents = map.getLayersRecursive(function(layer) {
		return layer.isSelected() && layer instanceof gc.gis.layer.GCGroupLayer;
	});

	var group = new gc.gis.layer.GCGroupLayer({
		label: 'Neue Gruppe',
		expanded: true,
		visible: true
	});

	if (parents.length > 0)
	{
		parents[0].addLayer(group);
	}
	else
	{
		map.addLayer(group);
	}
};